import { render, staticRenderFns } from "./edit-crossing-type.vue?vue&type=template&id=09237605&scoped=true"
import script from "./edit-crossing-type.vue?vue&type=script&lang=js"
export * from "./edit-crossing-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09237605",
  null
  
)

export default component.exports